import React from 'react';

class CadastrarOrcamentoConf extends React.Component {

    render() {
        return(
            <div>
                <br />
                <p id="cadorcamento-conf-alerta">
                    Após o cadastro, não será possível editar as informações do orçamento. Verifique 
                    estas <br />informações antes de confirmar o cadastro.
                </p><br /><br />
                <p id="cadorcamento-conf-ano">
                    <b>Ano:</b> { this.props.ano }
                </p><br />
                <table id="cadorcamento-conf-tbl">
                    <tbody>
                        <tr>
                            <td><b>Janeiro:</b></td>
                            <td>{ this.props.janeiro !== "" && "R$ " } { this.props.janeiro }</td>
                        </tr>
                        <tr>
                            <td><b>Fevereiro:</b></td>
                            <td>{ this.props.fevereiro !== "" && "R$ " } { this.props.fevereiro }</td>
                        </tr>
                        <tr>
                            <td><b>Março:</b></td>
                            <td>{ this.props.marco !== "" && "R$ " } { this.props.marco }</td>
                        </tr>
                        <tr>
                            <td><b>Abril:</b></td>
                            <td>{ this.props.abril !== "" && "R$ " } { this.props.abril }</td>
                        </tr>
                        <tr>
                            <td><b>Maio:</b></td>
                            <td>{ this.props.maio !== "" && "R$ " } { this.props.maio }</td>
                        </tr>
                        <tr>
                            <td><b>Junho:</b></td>
                            <td>{ this.props.junho !== "" && "R$ " } { this.props.junho }</td>
                        </tr>
                        <tr>
                            <td><b>Julho:</b></td>
                            <td>{ this.props.julho !== "" && "R$ " } { this.props.julho }</td>
                        </tr>
                        <tr>
                            <td><b>Agosto:</b></td>
                            <td>{ this.props.agosto !== "" && "R$ " } { this.props.agosto }</td>
                        </tr>
                        <tr>
                            <td><b>Setembro:</b></td>
                            <td>{ this.props.setembro !== "" && "R$ " } { this.props.setembro }</td>
                        </tr>
                        <tr>
                            <td><b>Outubro:</b></td>
                            <td>{ this.props.outubro !== "" && "R$ " } { this.props.outubro }</td>
                        </tr>
                        <tr>
                            <td><b>Novembro:</b></td>
                            <td>{ this.props.novembro !== "" && "R$ " } { this.props.novembro }</td>
                        </tr>
                        <tr>
                            <td><b>Dezembro:</b></td>
                            <td>{ this.props.dezembro !== "" && "R$ " } { this.props.dezembro }</td>
                        </tr>
                        <tr>
                            <td><b>Total:</b></td>
                            <td>{ this.props.total !== "" && "R$ " } { this.props.total }</td>
                        </tr>
                        <tr>
                            <td><b>Comentário:</b></td>
                            <td>{ this.props.comentario }</td>
                        </tr>
                    </tbody>
                </table><br /><br />
                <form id="cadorcamento-conf-form">
                    <button type="button" id="cadorcamento-voltar-btn" onClick={ this.props.voltar }>
                        Voltar
                    </button>
                    <button type="button"
                        id="cadorcamento-confirmar-btn"
                        onClick={ this.props.confirmar }
                        disabled={ this.props.disabled }>
                        Confirmar
                    </button>
                    <br /><br />
                </form>
            </div>
        );
    }

}

export default CadastrarOrcamentoConf;

